import { 
	createSlice,
	createSelector,
	createAsyncThunk,
	createEntityAdapter
} from '@reduxjs/toolkit'
import {envAwarePost} from '../../util/util'

export const addLeaderboardRecord = createAsyncThunk(
	'ai-demo/addLeaderboardRecord',
	async payload => await envAwarePost('api/ai-demo/',{
		action:'addLeaderboardRecord',
		...payload
	})
)

export const getSquatLeaderboard = createAsyncThunk(
	'ai-demo/getSquatLeaderboard',
	async payload => await envAwarePost(
		'api/ai-demo/',
		{action:'getSquatLeaderboard'}
	)
)

export const editLeaderboardRecord = createAsyncThunk(
	'ai-demo/editLeaderboardRecord',
	async payload => await envAwarePost(
		'api/ai-demo/',
		{action:'editLeaderboardRecord',...payload}
	)
)

export const removeLeaderboardRecord = createAsyncThunk(
	'ai-demo/removeLeaderboardRecord',
	async id => await envAwarePost(
		'api/ai-demo/',
		{action:'removeLeaderboardRecord',id}
	)
)

export const upsertMetricCategoryData = createAsyncThunk(
	'upsertMetricCategoryData',
	async (_,{getState})=>{
		//data in the redux store is in slightly different format than is expected 
		//by the api. Create data structure in form expected by API.
		const state = getState()
		const {category,client,date,metrics,aiLog} = state.ai.metricCreator
		const request = {
			action:'upsertMetricCategoryData',
			category_name:category,
			client_id:client,
			date,
			ai_log:aiLog,
			metrics: metrics.map(m=>({
				...m, 
				stats:[{
					value:m.value,
					notes:'',
					date
				}] 
			}))
		}
		const res = await envAwarePost(
			'api/metrics/',
			request
		)

		return res
	}
)

const leaderboardAdapter = createEntityAdapter()

const slice = createSlice({
	name: 'ai',
	initialState : {
		show:false,
		poses:[],
		demo:'squat',
		//map from log viewer id to current index being viewed
		//and the unix timestamp of the data point and the demo being viewed. 
		//eg: {123:{idx:2,t:434}}
		logViewers:{},
		leaderboard:leaderboardAdapter.getInitialState({
			status:'init'
		}),
		metricCreator:{
			show:false,
			category:null,
			client:null,
			date:null,
			metrics:null
		}
	},
	reducers : {
		setDemo: (state,action)=>{
			state.demo = action.payload
		},
		setLogViewer: (state,action)=>{
			const {update,id} = action.payload
			state.logViewers[id] = {
				...state.logViewers[id],
				...update
			}
		},
		setMetricCreator: (state,action)=>{
			state.metricCreator = {
				...state.metricCreator,
				...action.payload
			}
		},
		setStatus: (state,action)=>{
			state.status = action.payload
		},
		setShow : (state,action) => { 
			state.show = action.payload 
		},
		setPoses : (state,action) => {
			state.poses = action.payload
		}
	},
	extraReducers : {
		[addLeaderboardRecord.fulfilled] : (state,action)=>{
			leaderboardAdapter.upsertOne(
				state.leaderboard,
				action.payload.data.record
			)
		},
		[getSquatLeaderboard.pending] : (state)=>{
			state.leaderboard.status = 'pending'
		},
		[getSquatLeaderboard.fulfilled] : (state,action)=>{
			leaderboardAdapter.upsertMany(
				state.leaderboard,
				action.payload.data.leaderboard
			)
		},
		[editLeaderboardRecord.pending] : (state,action)=>{
			const {id,update:changes} = action.meta.arg
			leaderboardAdapter.updateOne(state.leaderboard,{id,changes})
		},
		[removeLeaderboardRecord.pending] : (state,action)=>{
			const id = action.meta.arg
			leaderboardAdapter.removeOne(state.leaderboard,id)
		}
	}
})

export const {
	setMetricCreator,
	setLogViewer,
	setStatus,
	setPoses,
	setShow,
	setDemo
} = slice.actions

export const selectMetricCreator = state => state.ai.metricCreator

// Export the customized selectors for this itemsAdapter using `getSelectors`
export const {
	selectAll: selectAllLeaderboardRecords,
	selectById: selectLeaderboardRecordById,
	selectIds: selectLeaderboardRecordIds
} = leaderboardAdapter.getSelectors( state => state.ai.leaderboard )


export default slice.reducer